<template>
  <div class="notice-box">
      <div class="text1 fw600 mb30 flex flex-between" style="align-items: center">
      <p></p>
      <div class="flex">
        <img
          @click="$router.push({ name: 'Notice' })"
          style="width: 30px; height: 30px; cursor: pointer"
          src="~@/assets/images/img59.png"
          alt
          title="返回"
        />
      </div>
    </div>
    <div class="header">
      <div class="text1">{{ sjdata.titleName}}</div>
      <div class="header-info">
        <div class="info-box flex align-items-center flex-center">
          <div>上传时间: {{ sjdata.createTime}}
            <!-- <span style="color: #927451">{{ sjdata.createTime}}</span> -->
          </div>
          <!-- <div style="margin-left: 75px">
            上传人 :<span style="color: #927451">{{ sjdata.createBy}}</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="content" v-html="replaceLinksWithIframe(sjdata.noticeContent)">

    </div>
  </div>
</template>

<script>
import { getAction} from "@/api/index";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      id:'',
      loading:false,
      sjdata:{},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.id=this.$route.query.id;
    this.getData();
  },
  methods: {
    replaceLinksWithIframe(inputString) {
       if (typeof inputString !== 'string') {
        console.warn('Invalid input string:', inputString);
        return inputString; // 如果不是有效字符串，则返回原始输入
      }
      const regex = /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/g;
      const updatedString =inputString.replace(regex, (match, href, text) => {
        // 检查链接是否为MP4文件
        if (href.endsWith('.mp4')) {
          return `<video controls width="100%" height="700px">
                    <source src="${href}" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>`;
        } else if (/\.(jpg|jpeg|png|gif|bmp)$/i.test(href)) {
          return `<img src="${href}" alt="${text}" style="max-width: 100%; height: auto; display: block; margin: 0 auto;">`;
        }else  if(href.endsWith('.pdf')){
          return `<iframe src="${href}" width="100%" height="800px" frameborder="0"></iframe>`;
        }
      });
       return updatedString.replace(/<img[^>]*>/g, (imgTag) => {
        // 如果 <img> 标签已有 style 属性，就不加重复的 style
        if (imgTag.includes('style="')) {
          return imgTag; // 保持原样
        }

        // 为 <img> 标签添加 style 属性
        return imgTag.replace(/<img /, '<img style="max-width: 100%; height: auto; display: block; margin: 0 auto;" ');
      });
    },
    getData(){
       let params={
         id:this.id
      }
      getAction("/lxbase/lxNotice/queryById", params).then((res) => {
          if (res.code === 200) {
            console.log(res);
            if(res.code=='200'){
               this.sjdata=res.result;
            }
           
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
       });
    }
  },
};
</script>

<style scoped lang="scss">
.notice-box {
  padding: 15px 30px;
}
.text1 {
  font-size: 26px;
  margin-top: 10px;
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}
.fw600 {
  font-weight: 600;
}
.mb30 {
  margin-bottom: 20px;
}
.header {
  .header-info {
    height: 38px;
    margin-top: 20px;
    // background: #fff6ec;
    .info-box {
      height: 100%;
    }
  }
}
.content {
  margin-top: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #282828;
  line-height: 46px;
  padding:0px 30px 30px;
  box-sizing: border-box;
  .division-box {
    margin-top:15px;
    .top-card {
      width: 160px;
      height: 34px;
      line-height: 36px;
      text-align: center;
      border-radius: 10px 10px 0px 0px;
      color: #fff6ec;
      background: #2155B5;
    }
    .bottom-line {
      height: 3px;
      background: #2155B5;
    }
  }
}
</style>
